import { ComponentsOverrides, Theme } from "@mui/material";

const buttonBase = (): ComponentsOverrides<Theme>["MuiButtonBase"] => ({
  root: {
    borderRadius: "8px",
  },
});

export default buttonBase;
